import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import PortalsSwitch from './PortalsSwitch';
import appRoutes from '../../appRoutes';
import Microsoft from '../../../screens/Settings/SsoConfigurations/Microsoft';
import StudioRouteGate from '../../../screens/Studio/StudioRouteGate';

const HomeScreen = lazy(() => import('../../../screens/Home'));
const WallBoard = lazy(() => import('../../../screens/WallBoard'));
const BoardShowScreen = lazy(() => import('../../../screens/BoardShow'));
const BoardsScreen = lazy(() => import('../../../screens/Boards'));
const TargetsAppShow = lazy(() => import('../../../screens/TargetsAppShow'));
const SignOutScreen = lazy(() => import('../../../screens/SignOut'));
const SharedIndexScreen = lazy(() => import('../../../screens/SharedIndex'));
const EntityDetailsShow = lazy(
  () => import('../../../screens/EntityDetailsShow'),
);
const EntityDetailsShowRedirect = lazy(
  () => import('../../../screens/EntityDetailsShowRedirect'),
);
const MyAccountScreen = lazy(() => import('../../../screens/MyAccount'));
const ReportShow = lazy(() => import('../../../screens/ReportShow'));
const DashboardShow = lazy(() => import('../../../screens/DashboardShow'));
const Studio = lazy(() => import('../../../screens/Studio'));
const StudioContentLoader = lazy(
  () => import('../../../screens/Studio/StudioContentLoader'),
);
const WorkSpacesIndex = lazy(() => import('../../../screens/WorkSpacesIndex'));
const WorkSpacesShow = lazy(() => import('../../../screens/WorkSpacesShow'));

const ScorecardShow = lazy(() => import('../../../screens/ScorecardShow'));
const GoalShow = lazy(() => import('../../../screens/GoalShow'));
const MotiveOAuthRedirect = lazy(
  () => import('../../../screens/Settings/Integrations/MotiveOAuthRedirect'),
);

const PortalModeSwitch = () => {
  return (
    <Routes>
      ”<Route path={appRoutes.home} element={<HomeScreen />} />
      <Route
        path={appRoutes.loggedIn.workspaces}
        element={<WorkSpacesIndex />}
      />
      <Route
        path={appRoutes.loggedIn.showWorkSpace}
        element={<WorkSpacesShow />}
      />
      <Route
        path={appRoutes.loggedIn.showWorkSpaceTab}
        element={<WorkSpacesShow />}
      />
      <Route path={appRoutes.loggedIn.shared} element={<SharedIndexScreen />} />
      <Route
        path={`/shared${appRoutes.loggedIn.showDashboard}`}
        element={<DashboardShow />}
      />
      <Route
        path={`/shared${appRoutes.loggedIn.showReport}`}
        element={<ReportShow />}
      />
      <Route
        path={`/shared${appRoutes.loggedIn.showGlobalKpiList}`}
        element={<ScorecardShow />}
      />
      <Route
        path={appRoutes.loggedIn.showDashboard}
        element={<DashboardShow />}
      />
      <Route path={appRoutes.loggedIn.showReport} element={<ReportShow />} />
      <Route
        path={appRoutes.loggedIn.showGlobalKpiList}
        element={<ScorecardShow />}
      />
      <Route path={appRoutes.loggedIn.showWallBoard} element={<WallBoard />} />
      <Route
        path={appRoutes.loggedIn.entityAppRedirect}
        element={<EntityDetailsShowRedirect />}
      />
      <Route
        path={appRoutes.loggedIn.showEntityApp}
        element={<EntityDetailsShow />}
      />
      <Route
        path={appRoutes.loggedIn.showEntityAppContentTab}
        element={<EntityDetailsShow />}
      />
      <Route
        path={appRoutes.loggedIn.myAccount}
        element={<MyAccountScreen />}
      />
      <Route path={appRoutes.loggedIn.boards} element={<BoardsScreen />} />
      <Route
        path={appRoutes.loggedIn.showBoard}
        element={<BoardShowScreen />}
      />
      <Route
        path={appRoutes.loggedIn.showTargetApp}
        element={<TargetsAppShow />}
      />
      <Route
        path={appRoutes.loggedIn.showTargetAppTasksTab}
        element={<TargetsAppShow />}
      />
      <Route
        path={appRoutes.loggedIn.showTargetAppContentTab}
        element={<TargetsAppShow />}
      />
      <Route path={appRoutes.loggedIn.showGlobalGoal} element={<GoalShow />} />
      <Route
        path={appRoutes.loggedIn.showCampaignGoal}
        element={<GoalShow />}
      />
      <Route
        path={appRoutes.loggedIn.microsoftSsoRedirect}
        element={<Microsoft.ConsentRedirect />}
      />
      <Route
        path={appRoutes.loggedIn.motiveOAuthRedirect}
        element={<MotiveOAuthRedirect />}
      />
      <Route path={appRoutes.loggedIn.signOut} element={<SignOutScreen />} />
      {/* Studio: Edit and Create New open it (see buildStudioEdit) */}
      <Route
        path={appRoutes.loggedIn.studio}
        element={
          <StudioRouteGate>
            <Studio />
          </StudioRouteGate>
        }
      />
      <Route
        path={appRoutes.loggedIn.studioEdit}
        element={
          <StudioRouteGate>
            <StudioContentLoader />
          </StudioRouteGate>
        }
      />
      <Route path={'/:portal/*'} element={<PortalsSwitch />} />
    </Routes>
  );
};

export default PortalModeSwitch;
